import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSession } from "../contexts/SessionContext";
import { CsrAPI } from "../apis/CsrAPI";
import { setSentryUser } from "../utils/Sentry";

export const LoginCallbackHandler = ({ children }) => {
  const { setSessionReady } = useSession();
  const { isAuthenticated, user } = useAuth0();

  React.useEffect(() => {
    const handleLogin = async () => {
      if (isAuthenticated) {
        setSessionReady(false);
        setSentryUser(user);
        await CsrAPI.login();
        setSessionReady(true);
      }
    };

    handleLogin();
  }, [isAuthenticated, setSessionReady, user]);

  return children;
};
